// Single source of truth for legal page metadata. The MDX bodies live in
// content/legal/*; this module pairs each one with a "last updated" date
// and a slug → page metadata. Kept tiny so the sitemap + footer + page
// metadata all share the same dates.

export type LegalSlug = "terms" | "privacy" | "refunds";

export type LegalPage = {
  slug: LegalSlug;
  title: string;
  description: string;
  lastUpdated: string; // ISO date - used in <time> tag and sitemap
  contentPath: string; // path under content/
};

export const LEGAL_PAGES: Record<LegalSlug, LegalPage> = {
  terms: {
    slug: "terms",
    title: "Terms of Service",
    description: "The agreement between you and Swift MVP.",
    lastUpdated: "2026-04-27",
    contentPath: "content/legal/terms.mdx",
  },
  privacy: {
    slug: "privacy",
    title: "Privacy Policy",
    description: "What data we collect, why, and how we protect it.",
    lastUpdated: "2026-04-27",
    contentPath: "content/legal/privacy.mdx",
  },
  refunds: {
    slug: "refunds",
    title: "Refund Policy",
    description: "When and how we issue refunds for Swift MVP packages.",
    lastUpdated: "2026-04-27",
    contentPath: "content/legal/refunds.mdx",
  },
};

export const LEGAL_LINKS: { href: string; label: string }[] = [
  { href: "/terms", label: "Terms" },
  { href: "/privacy", label: "Privacy" },
  { href: "/refunds", label: "Refunds" },
];
